import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_SRC, NAV_LINKS } from "@/lib/site";
import { scrollToId } from "@/lib/scroll";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="main-header"
      className={`fixed inset-x-0 top-0 z-50 bg-white/95 backdrop-blur-xl transition-shadow duration-500 ${
        scrolled || open ? "shadow-[0_10px_34px_-14px_rgba(12,95,138,0.3)]" : "shadow-[0_4px_20px_-10px_rgba(12,95,138,0.18)]"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#inicio" onClick={(e) => go(e, "inicio")} data-testid="header-logo-link" aria-label="Seguclick, ir al inicio" className="flex items-center">
          <img src={LOGO_SRC} alt="Seguclick — agencia de seguros familiar" className="h-9 w-auto sm:h-11" />
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Navegación principal">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => go(e, link.id)}
              data-testid={`nav-link-${link.id}`}
              className="font-display text-sm font-medium tracking-wide text-[#0C5F8A] transition-colors duration-300 hover:text-[#F5B21B]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contacto"
            onClick={(e) => go(e, "contacto")}
            data-testid="header-cta-cotiza"
            className="hidden rounded-full bg-[#F5B21B] px-6 py-2.5 font-display text-sm font-semibold text-[#0C5F8A] shadow-[0_8px_20px_-6px_rgba(245,178,27,0.6)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#E0A012] sm:inline-block"
          >
            Cotiza tu seguro
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-label={open ? "Cerrar menú" : "Abrir menú"}
            onClick={() => setOpen(!open)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full text-[#0C5F8A] transition-colors hover:bg-[#E8F6FD] lg:hidden"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      <div
        data-testid="mobile-menu"
        className={`overflow-hidden transition-[max-height] duration-500 lg:hidden ${open ? "max-h-[420px]" : "max-h-0"}`}
      >
        <nav className="flex flex-col gap-1 bg-white px-5 pb-6 pt-2" aria-label="Navegación móvil">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => go(e, link.id)}
              data-testid={`mobile-nav-link-${link.id}`}
              className="rounded-xl px-4 py-3 font-display text-base font-medium text-[#0C5F8A] transition-colors hover:bg-[#E8F6FD]"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => go(e, "contacto")}
            data-testid="mobile-cta-cotiza"
            className="mt-3 rounded-full bg-[#F5B21B] px-6 py-3 text-center font-display text-sm font-semibold text-[#0C5F8A]"
          >
            Cotiza tu seguro
          </a>
        </nav>
      </div>
    </header>
  );
};
